import { Icon } from '@spotnana/blocks/src/Icon';
import { Typography } from '@spotnana/blocks/src/Typography';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  segment_description,
  min_width_container,
  segment_title_container,
  arrow_right_icon_container,
} from './styles';

interface OriginToDestinationHeadingProps {
  /**
   * @example
   * "San Francisco (SFO)"
   */
  origin: string;
  destination: string;
  /**
   * As of now children are just the Labels such as OutOfPolicy and SeparateTickets
   */
  children?: React.ReactNode;
}

const OriginToDestinationHeading: FC<OriginToDestinationHeadingProps> = ({ origin, destination, children }) => {
  const { t: tt } = useTranslation('WEB');
  return (
    <div css={segment_description}>
      <div css={min_width_container}>
        <div css={segment_title_container}>
          <Typography variant="header4" as="h3" data-testid="leg-origin_new" aria-label={tt('Origin Name')}>
            {origin}
          </Typography>
          <div css={arrow_right_icon_container}>
            <Icon name="ArrowRight" data-testid="leg-separator-icon" title={tt('to')} variant="standalone" />
          </div>
          <Typography variant="header4" as="h3" data-testid="leg-destination_new" aria-label={tt('Destination Name')}>
            {destination}
          </Typography>
        </div>
        {children}
      </div>
    </div>
  );
};

export default OriginToDestinationHeading;
